import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isOpen: false,
    styleId: null,
    styleInfo: null,
    isShowConversation: true,
    isHideBottom: false,
    requestFrom: null,
    collectionMembers: [],
    toggleFavouriteHandler: null
}

const designViewSlice = createSlice({
    name: 'designView',
    initialState,
    reducers: {
        openDesignView: (state, action) => {
            state.isOpen = true
            state.styleId = action.payload.styleId
            state.styleInfo = action.payload.styleInfo
            state.isShowConversation = action.payload.isShowConversation ?? true
            state.isHideBottom = action.payload.isHideBottom ?? false
            state.requestFrom = action.payload.requestFrom
            state.collectionMembers = []
            state.toggleFavouriteHandler = action.payload.toggleFavouriteHandler
        },
        closeDesignView: (state) => {
            return initialState
        },
        setCollectionMembers: (state, action) => {
            state.collectionMembers = action.payload
        }
    }
})

export const { openDesignView, closeDesignView, setCollectionMembers } =
    designViewSlice.actions

export const useDesignView = (state) => state.designView

export default designViewSlice.reducer
